/* eslint-disable react/display-name */
import React, { useContext, useEffect } from 'react'
import { Modal } from 'antd'

import { UnitSelectionContext } from 'context'
import {
  getUnits,
  getUtilityNameMap,
  getUnitTypeCode,
  getUnitGroups,
  getUtilityUnitsMap,
  getEnvConfig,
  getPermitActions,
} from 'core/selectors'
import { connect } from 'react-redux'
// import UnitSelectionBarConnecxt from 'core/component/UnitSelection'
import { UnitSelectionBar } from './../../core/component/UnitSelection'

const SelectUnits = ({ visible, ...props }) => {
  // const { visible } = props
  const { setVisibleUnitSelection } = useContext(UnitSelectionContext)
  useEffect(_ => setVisibleUnitSelection(visible), [
    visible,
    setVisibleUnitSelection,
  ])
  return (
    <Modal
      footer={null}
      // title={props.title}
      visible={visible}
      onOk={e => {
        setVisibleUnitSelection(false)
        props.onOk(e)
      }}
      onCancel={_ => {
        setVisibleUnitSelection(false)
        props.onCancel()
      }}
      width={1200}
      height="100%"
      title={null}
      // style={{ top: 10, backgroundColor: 'red' }}
      style={{ top: 10 }}
      afterClose={_ => setVisibleUnitSelection(false)}
      bodyStyle={{ minHeight: '100%', maxHeight: '100%', height: '100%' }}
      destroyOnClose
    >
      <UnitSelectionBar
        accesskey="u"
        style={{ margin: '0px', padding: '0px' }}
        hideSelectedUnits
        setData={_ => {
          setVisibleUnitSelection(false)
          props.modalClose()
        }}
        close={_ => {
          setVisibleUnitSelection(false)
          props.modalClose()
        }}
        contendDivStyle={{ minHeight: '60vh' }}
        retrieveData={e => {
          setVisibleUnitSelection(false)
          props.onOk(e)
        }}
        showwarning={false}
        {...props}
        units={props.unitList || props.units}
      />
    </Modal>
  )
}

const mapStateToProps = state => ({
  units: getUnits(state),
  utilityNameMap: getUtilityNameMap(state),
  unitTypeCode: getUnitTypeCode(state),
  unitGroups: getUnitGroups(state),
  utlityUnitMap: getUtilityUnitsMap(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(SelectUnits)
